import {Component} from "./Component";
import {AjaxNavigation} from "./AjaxNavigation";


/**
 * Shows notification messages
 */
export class Notifications extends Component {
    static name = "notifications";

    static instance = null;

    get name() {
        return Notifications.name;
    }

    constructor(el) {
        super(el);

        this.$text = this.$("text");
        this.$dismiss = this.$("dismiss");

        this.addEventListener(document.body, "notifications:notification", this.onNotification.bind(this));
        this.addEventListener(document.body, "notifications:hide", this.onDismiss.bind(this));

        this.addEventListener(window, "onpopstate", this.onPopState.bind(this));

        this.addEventListener(document.body, AjaxNavigation.EVENT_LOAD_END, this.onLoadEndAjaxNavigation.bind(this));

        this.addEventListener(this.$dismiss, "click", this.onDismiss.bind(this));

        Notifications.instance = this;

        const url = new URL(window.location.href);
        if (url.searchParams.has("message")) {
            this.show(url.searchParams.get("message"), url.searchParams.get("message_type") || "info");

            url.searchParams.delete("message");
            url.searchParams.delete("message_type");

            window.history.pushState(null, "", url);
        }
    }


    onLoadEndAjaxNavigation(e) {
                this.showMessageFromUrl();
    }

    /**
     * popstate listener shows message if message query param is present
     * @param e
     */
    onPopState(e) {
        this.showMessageFromUrl();
    }

    /**
     *
     * @param {string|undefined} url Optional url, defaults to current url
     */
    showMessageFromUrl(url = undefined) {
        url = new URL(url || window.location.href);

        if (url.searchParams.has("message")) {
            this.show(url.searchParams.get("message"), url.searchParams.get("message_type") || "info");
        }
    }

    /**
     *
     * @param {CustomEvent} e
     */
    onNotification(e) {
        const {message, type = "info"} = e.detail;
        this.show(message, type);
    }

    /**
     *
     * @param {MouseEvent} e
     */
    onDismiss(e) {
        this.hide();
    }

    show(message, type = "info") {
        this.$text.innerHTML = message;
        this.el.classList.add("notifications--visible", `notification-${type}`);
    }

    hide() {
        this.el.classList.remove("notifications--visible");
    }

    /**
     * Shows notification message
     * @param message
     * @param type
     */
    static showMessage(message, type = "info") {
        document.body.dispatchEvent(new CustomEvent("notifications:notification", {
            bubbles: true,
            detail: {
                message,
                type,
            }
        }));
    }

    static showInfo(message) {
        this.showMessage(message);
    }

    static showError(message) {
        this.showMessage(message, "error");
    }

    /**
     * Hides notificaton message
     */
    static hideMessage() {
        document.body.dispatchEvent(new CustomEvent("notifications:hide", {
            bubbles: true,
        }));
    }

}
